var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"dense":"","flat":"","height":"60"}},[_c('div',{staticClass:"d-flex align-center"},[_c('v-img',{staticClass:"shrink mr-2",attrs:{"alt":"Logo","contain":"","src":require("../../public/assets/logo.svg"),"width":"70"}})],1),_c('v-spacer'),_c('LocaleSwitcher')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }